import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CameraIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="camera" ref={ref} {...props}>
      <path d="M18.09,6.14H16.58c-.5,0-.68,0-.92-.62a2.27,2.27,0,0,0-2.29-1.6H10.66a2.26,2.26,0,0,0-2.29,1.6c-.24.57-.42.62-.93.62H5.94A2.83,2.83,0,0,0,3.25,9v8.76a2.84,2.84,0,0,0,2.84,2.84H17.91a2.84,2.84,0,0,0,2.84-2.84V9A2.83,2.83,0,0,0,18.09,6.14Zm1.16,11.59a1.34,1.34,0,0,1-1.34,1.34H6.09a1.34,1.34,0,0,1-1.34-1.34V9A1.34,1.34,0,0,1,6.09,7.63H7.44A2.24,2.24,0,0,0,9.75,6.1c.26-.61.41-.69.91-.69h2.71c.49,0,.65.08.91.69a2.23,2.23,0,0,0,2.3,1.53h1.36A1.34,1.34,0,0,1,19.25,9ZM12,17.23a4.13,4.13,0,1,1,4.12-4.12A4.13,4.13,0,0,1,12,17.23Zm0-6.75a2.63,2.63,0,1,0,2.62,2.63A2.62,2.62,0,0,0,12,10.48Z" />
    </Icon>
  ),
) as IconWithRender;

CameraIcon.displayName = 'CameraIcon';
CameraIcon.renderIcon = (props) => <CameraIcon {...props} />;
export default CameraIcon;
